'use strict';

import SearchRoutesForm from "../components/SearchRoutesForm";

class HomeSearchContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <div>
            <div className="main-section__title">
                {__('home.search.title')}
            </div>
            <SearchRoutesForm
                showSwitchTab={true}
            />
        </div>
    }
}

const domContainer = document.querySelector('#reactHomeSearchContainer');
const root = ReactDOM.createRoot(domContainer);
root.render(React.createElement(HomeSearchContainer));
